module.exports = __webpack_public_path__ + "img/mc_acc.68f07e45.svg";